import { PRINT_JOB_STATUS } from '../../services/shipstation-connect/connect-printers';
import { baseReducer as BaseReducer } from '../../store/core/base-reducer';

import * as Actions from './ss-connect.actions';
import { ConnectReducerHelper } from './connect-reducer-helper';
import { APP_INITIALIZATION } from '../core/base-actions';

const initialState = {
  workstations: [],
  scales: [],
  defaultScale: undefined,
  printers: [],
  printJobs: [],
};

const actionHandlerMap = {
  [Actions.UPDATE_SCALES_SUCCESS]: (state, { workstationId, scales }) => ({
    ...state,
    workstations: ConnectReducerHelper.setWorkstationOnlineStatus(workstationId, state.workstations, true),
    scales: ConnectReducerHelper.updateScalesMatrix(workstationId, scales, state.scales),
  }),
  [Actions.SET_DEFAULT_SCALE]: (state, { defaultScale }) => ({
    ...state,
    defaultScale,
  }),
  [Actions.RESTORE_DEFAULT_SCALE]: (state, { defaultScale }) => ({
    ...state,
    defaultScale,
  }),
  [Actions.UPDATE_PRINTERS_SUCCESS]: (state, { workstationId, printers }) => ({
    ...state,
    workstations: ConnectReducerHelper.setWorkstationOnlineStatus(workstationId, state.workstations, true),
    printers: ConnectReducerHelper.updatePrintersMatrix(workstationId, printers, state.printers),
  }),
  [Actions.UPDATE_PRINTERS_FAILURE]: (state, { workstationId, getPrintersError }) => ({
    ...state,
    printers: ConnectReducerHelper.updatePrintersMatrix(workstationId, [], state.printers, getPrintersError),
  }),
  [Actions.PRINT_DOCUMENT_REQUEST]: (state, { printJob }) => ({
    ...state,
    printJobs: [...state.printJobs, printJob],
  }),
  [Actions.PRINT_DOCUMENT_PENDING]: (state, { requestId }) => ({
    ...state,
    printJobs: ConnectReducerHelper.updateJobStatus(state.printJobs, requestId, PRINT_JOB_STATUS.STATUS_PENDING),
  }),
  [Actions.PRINT_DOCUMENT_SUCCESS]: (state, { requestId }) => ({
    ...state,
    printJobs: ConnectReducerHelper.updateJobStatus(state.printJobs, requestId, PRINT_JOB_STATUS.STATUS_SUCCESS),
  }),
  [Actions.PRINT_DOCUMENT_FAILURE]: (state, { requestId, error }) => ({
    ...state,
    printJobs: ConnectReducerHelper.updateJobStatus(state.printJobs, requestId, PRINT_JOB_STATUS.STATUS_FAILURE, error),
  }),
  [Actions.PRINT_DOCUMENT_COMPLETE]: (state, { requestId }) => ({
    ...state,
    printJobs: ConnectReducerHelper.removePrintJob(state.printJobs, requestId),
  }),
  [APP_INITIALIZATION]: (state, { initialData }) => {
    const { workstations } = initialData;
    const updatedWorkstations = workstations.map((w) => {
      const { workstationId } = w;
      const existingWorkstation = state.workstations.find((sw) => sw.workstationId === workstationId) || {};
      return {
        ...existingWorkstation,
        ...w,
      };
    });
    return {
      ...state,
      workstations: updatedWorkstations,
    };
  },
  [Actions.GET_WORKSTATIONS_SUCCESS]: (state, { workstations }) => {
    const updatedWorkstations = workstations.map((w) => {
      const { workstationId } = w;
      const existingWorkstation = state.workstations.find((sw) => sw.workstationId === workstationId) || {};
      return {
        ...existingWorkstation,
        ...w,
      };
    });
    return {
      ...state,
      workstations: updatedWorkstations,
    };
  },
  [Actions.UPDATE_WORKSTATION_SUCCESS]: (state, { workstation }) => {
    const { workstations } = state;
    const updatedWorkstations = workstations.map((w) => (w.workstationId === workstation.workstationId ? workstation : w));
    return {
      ...state,
      workstations: updatedWorkstations,
    };
  },
  [Actions.CLEAR_DEVICES_FOR_WORKSTATION]: (state, { workstationId }) => ({
    ...state,
    workstations: ConnectReducerHelper.setWorkstationOnlineStatus(workstationId, state.workstations, false),
    scales: state.scales.filter((scaleGroup) => scaleGroup.workstationId !== workstationId),
    printers: state.printers.filter((printerGroup) => printerGroup.workstationId !== workstationId),
  }),
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './ss-connect.reducer.metadata';
